import API, { APIResponse } from '../commons/api'
import { WbsItemType } from '../../domain/entity/WbsItemEntity'
import { SprintDetail } from './sprint'
import { TagForWbsItem } from './tag'
import { WbsItemSearchConditionV2Request } from '../../services/model/wbsItemSearchConditionV2ApiRequest'

export interface WbsItemIndexUser {
  uuid: string
  name?: string
  code?: string
  nameAlphabet?: string
  nameKana?: string
}

export interface WbsItemIndex {
  projectUuid: string
  uuid: string
  code: string
  type: WbsItemType
  status: string
  displayName: string
  description?: string
  lockVersion?: number
  revision?: string
  substatus?: string
  team?: {
    uuid: string
    code?: string
    displayName?: string
    officialName?: string
  }
  accountable?: WbsItemIndexUser
  responsible?: WbsItemIndexUser
  assignee?: WbsItemIndexUser
  closedBy?: WbsItemIndexUser
  critical?: boolean
  deadline?: string
  difficulty?: string
  estimatedStoryPoint?: number
  estimatedHour?: number
  actualHour?: number
  scheduledStartDate?: string
  scheduledEndDate?: string
  actualStartDate?: string
  actualEndDate?: string
  createdAt: string
  updatedAt: string
  createdBy: WbsItemIndexUser
  updatedBy: WbsItemIndexUser
  sprints?: SprintDetail[]
  tags?: TagForWbsItem[]
  deliverable?: { uuid: string; code?: string; displayName?: string }
  ticketType?: string
  priority?: string
  path?: string
  parentWbsItem?: {
    uuid: string
    displayName?: string
    type?: WbsItemType
  }
}

export const searchWbsItemV2 = (
  request: WbsItemSearchConditionV2Request
): Promise<APIResponse> => {
  return API.functional.request(
    'POST',
    '/api/v1/projects/wbs_items/search',
    request
  )
}

export const countSearchWbsItemV2 = (
  request: WbsItemSearchConditionV2Request
): Promise<APIResponse> => {
  return API.functional.request(
    'POST',
    '/api/v1/projects/wbs_items/search/count',
    request
  )
}
